import * as z from "zod/v4";

export const setPreferredSupportEmail = {
  name: "setPreferredSupportEmail" as const,
  input: z.object({ email: z.string().nullable() }),
  output: z.null(),
};
